<script setup lang="ts">
import { useDisconnect } from '@wagmi/vue';

import { useNuxtApp } from '#app';

const { '$wagmi': { 'switchModal': { isOpenSwitchModal, setVisibleSwitchModal }, 'networksList': { setVisibleNetworkList } } } = useNuxtApp();

const { disconnect, 'isPending': isPendingDisconnect } = useDisconnect({
    mutation: {
        onSuccess: () => setVisibleSwitchModal(false)
    }
});

const onSwitch = () => {
    setVisibleSwitchModal(false);
    setTimeout(
        () => setVisibleNetworkList(true),
        300
    );
};
</script>

<template>
  <Modal class="modal"
         :model-value="isOpenSwitchModal"
         @update:model-value="setVisibleSwitchModal"
  >
    <h2 class="display-800-accent">
      Your wallet is not on the chosen network
    </h2>
    <span class="text-700-default">You have connected to a different network, please change it</span>
    <div class="display-flex flex-row modal-buttons">
      <button :disabled="isPendingDisconnect"
              class="modal-btn modal-btn__disconnect"
              type="button"
              aria-label="disconnect"
              @click="disconnect()"
      >
        <Transition name="fade"
                    mode="out-in"
        >
          <LoaderDots v-if="isPendingDisconnect"
                      key="pending"
          />
          <span v-else
                key="disconnect"
                class="compact-500-accent"
          >Disconnect</span>
        </Transition>
      </button>
      <button :disabled="isPendingDisconnect"
              class="modal-btn modal-btn__switch"
              type="button"
              @click="onSwitch"
      >
        <span class="compact-500-accent">Switch network</span>
      </button>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>

:deep(.modal) {
  max-width: 740px;
  background-color: var(--layer-floor-2);
}

.modal {
  &-buttons {
    height: 52px;
    margin-top: 32px;
  }

  &-btn {
    flex-grow: 1;
    transition: all 0.3s ease-in-out;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    &__disconnect {
      background-color: transparent;

      span {
        color: var(--content-primary)
      }
    }

    &__switch {
      background-color: var(--bg-brand-mojito-primary, #92FE75);
    }
  }
}

</style>
